import { tradesBlotterApiConnector } from 'apiConnector/blotters';
import type { ServerSideBlotterSearchRequest } from 'apiConnector/blotters/common';
import type { TradesBlottersFilterProps } from 'components/Blotters/Trades/Filter/Filter.connect';
import type { StringFileResponse } from 'models/FileResponse';
import { useCallback } from 'react';
import { EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';
import { TradesOrProducts } from 'state/blotters/trades/types/blotterItem';
import { downloadCsv } from 'utils/documents/downloadDocument';
import { httpClient } from 'utils/http/httpClient';

import { logAnalytics } from '../../../../shared/middlewares/analytics/logger';

const api = tradesBlotterApiConnector(httpClient);

export function useDlpBlotterItemsFetch({ requestParams }: Pick<TradesBlottersFilterProps, 'requestParams'>) {
  return useCallback(() => {
    return api.dlpFetchCSV({ ...requestParams }).pipe(
      map((response: StringFileResponse) => {
        logAnalytics.trackEvent('Blotter My flow products', 'Download CSV');
        downloadCsv(response.data, response.filename);
      }),
    );
  }, [requestParams]);
}

export function useBlotterItemsFetch<T extends TradesOrProducts>(
  request: ServerSideBlotterSearchRequest | undefined,
  blotterTypeFilter: T,
) {
  return useCallback(() => {
    if (request === undefined) {
      return EMPTY;
    }
    return api.fetchCSV(request, blotterTypeFilter).pipe(
      map((response: StringFileResponse) => {
        logAnalytics.trackEvent('Blotter My Trades', 'Download CSV');
        downloadCsv(response.data, response.filename);
      }),
    );
  }, [request, blotterTypeFilter]);
}
